module.exports = require("react-slick");


//////////////////
// WEBPACK FOOTER
// external "react-slick"
// module id = 153
// module chunks = 0